<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-text-box-outline"
      inline
      class="px-5 py-3"
      title="Legales"
    >
      <template v-if="$can('M_legales_edita')" v-slot:after-title>
          <v-btn color="#ac8a2e" dark icon @click="goToNewLitigioForm('new', 0)">
            <v-icon
              large
              color="#ac8a2e"
            >
              mdi-text-box-plus-outline
            </v-icon>
          </v-btn>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="litigios"
        :search.sync="search"
        :sort-by="['fecha']"
        :sort-desc="[true, false]"
        multi-sort
      >
        <template v-slot:[`item.propio_sn`]="{ item }">
          <v-icon
            v-if="item.propio_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_legales_edita')" v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="goToNewLitigioForm('edit', item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_legales_edita')" v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToAsignaciones(item.id)">
                mdi-account-group
              </v-icon>
            </template>
            <span>Asignar litigio</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_legales_edita')" v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="goToHistorial(item.id)">
                mdi-forum
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        search: undefined,
        headers: [
          { text: 'Fecha', sortable: true, value: 'fecha' },
          { text: 'Contraparte', sortable: true, value: 'contraparte' },
          { text: 'Propio', value: 'propio_sn' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        litigios: [],
        editedIndex: -1,
        dataForm: {
          id: '',
          fecha: '',
          propio_sn: '',
          contraparte_user_id: '',
          contraparte_club_id: '',
          contraparte_otro: '',
          contraparte_contacto: '',
          detalle: '',
          documento_id: '',
          user_id: '',
          fecha_cierre: '',
          club: {
            id: '',
            descripcion: '',
          },
          user: {
            id: '',
            name: '',
          },
        },
      }
    },
    created () {
      this.getLitigios()
    },
    methods: {

      getLitigios: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/litigios_get_abiertos' }).then(response => { this.litigios = response })
      },

      goToNewLitigioForm: function (modeVal, idUser) {
        this.$router.push({ name: 'Alta Litigio', params: { mode: modeVal, id: idUser } })
      },

      goToAsignaciones: function (idLitigio) {
        this.$router.push({ name: 'Asignaciones legales', params: { id: idLitigio } })
      },

      goToHistorial: function (idLitigio) {
        this.$router.push({ name: 'Seguimiento legales', params: { id: idLitigio } })
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'También eliminará el seguimiento y las asignaciones.', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/litigios_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Litigio eliminado'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getLitigios()
      },
    },
  }
</script>
